module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "top": "0px",
      "right": "0px"
    },
    attrs: {
      "id": "shadesWrapper"
    }
  }, [_c('div', {
    staticClass: "fright full",
    attrs: {
      "id": "contentMenu"
    }
  }, [_c('div', {
    staticClass: "flexContainer ai-c jc-sb",
    attrs: {
      "id": "searchInputWrapper"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "full",
    attrs: {
      "id": "searchInput",
      "type": "search",
      "placeholder": _vm.$t('common.search')
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "keyup": _vm.searchShade,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ai-c"
  }, [(_vm.search !== '') ? _c('img', {
    staticClass: "cross pointer",
    attrs: {
      "id": "cross",
      "src": require("../../../assets/cross.png"),
      "alt": "",
      "width": "10",
      "height": "10"
    },
    on: {
      "click": _vm.reset
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ai-c"
  }, [_c('img', {
    staticClass: "pointer",
    attrs: {
      "id": "glass",
      "src": require("../../../assets/loupe.png")
    },
    on: {
      "click": _vm.searchShade
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "rel",
    attrs: {
      "id": "filtersShades"
    }
  }, [_c('ul', {
    staticClass: " flexContainer jc-sb",
    attrs: {
      "id": "relatedProducts"
    }
  }, _vm._l((_vm.products), function(product, index) {
    return _c('li', {
      key: product.id,
      staticClass: "rel flexContainer jc-c pointer uppercase iBlock",
      class: {
        active: _vm.productActive === index
      },
      on: {
        "click": function($event) {
          _vm.activeProduct(index, product.id);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(product.terms.name[_vm.$t("trad")]["value"]))])])
  })), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "flexContainer abs",
    attrs: {
      "id": "spinnerLoader"
    }
  }, [_c('Spinner', {
    staticClass: "loader",
    attrs: {
      "animation-duration": 5000,
      "size": 60,
      "color": '#41b4e8'
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.relProductId === undefined) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.noShades))])]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "scrollY",
    attrs: {
      "id": "shadesContent"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32d34612","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plano/menu/MenuShades.vue
// module id = 3113
// module chunks = 0